import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { renderHeaderButton } from '../../../../../store/headerButtonControl/duck';
import { updateUserDetails } from '../../../../../store/user/duck';
import StudioEditor from './component';

const container = connect(
  (state: any) => ({
    hotTopic: state.functions.hotTopic,
    userDetails: state.user.userDetails,
    teamCampaignCodes: state.functions.campaignCodes,
    teams: state.team.teams
  }),
  {
    renderHeaderButton,
    updateUserDetails
  }
)(StudioEditor);

export default injectIntl(container);
